import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_INVOICE_CANCELLATION_REASONS, GET_INVOICE_TAX_REGIME } from './constans';

export const getInvoiceCancellations = extendRoutine(createRoutine(GET_INVOICE_CANCELLATION_REASONS), 'RESET');
export const getInvoiceTaxRegime = extendRoutine(createRoutine(GET_INVOICE_TAX_REGIME), 'RESET');
